const formatAmountValue = (value) => {
  return Number(value).toLocaleString('en-US').replace(/,/g, ' ');
};

export default formatAmountValue;
